import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const IconError = ({ fontSize = 24, ...other }) => {
  const theme = useTheme();

  return (
    <Box component="span" display="block" {...other}>
      <svg width={fontSize} height={fontSize} viewBox="0 0 161 160" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M80.5002 113.333C82.3891 113.333 83.9724 112.694 85.2502 111.417C86.5279 110.139 87.1668 108.555 87.1668 106.667C87.1668 104.778 86.5279 103.194 85.2502 101.917C83.9724 100.639 82.3891 99.9999 80.5002 99.9999C78.6113 99.9999 77.0279 100.639 75.7502 101.917C74.4724 103.194 73.8335 104.778 73.8335 106.667C73.8335 108.555 74.4724 110.139 75.7502 111.417C77.0279 112.694 78.6113 113.333 80.5002 113.333ZM73.8335 86.6666H87.1668V46.6666H73.8335V86.6666ZM80.5002 146.667C71.2779 146.667 62.6113 144.917 54.5002 141.417C46.3891 137.917 39.3335 133.167 33.3335 127.167C27.3335 121.167 22.5835 114.111 19.0835 106C15.5835 97.8888 13.8335 89.2222 13.8335 79.9999C13.8335 70.7777 15.5835 62.111 19.0835 53.9999C22.5835 45.8888 27.3335 38.8333 33.3335 32.8333C39.3335 26.8333 46.3891 22.0833 54.5002 18.5833C62.6113 15.0833 71.2779 13.3333 80.5002 13.3333C89.7224 13.3333 98.3891 15.0833 106.5 18.5833C114.611 22.0833 121.667 26.8333 127.667 32.8333C133.667 38.8333 138.417 45.8888 141.917 53.9999C145.417 62.111 147.167 70.7777 147.167 79.9999C147.167 89.2222 145.417 97.8888 141.917 106C138.417 114.111 133.667 121.167 127.667 127.167C121.667 133.167 114.611 137.917 106.5 141.417C98.3891 144.917 89.7224 146.667 80.5002 146.667Z"
          fill={theme.palette.error.main}
        />
      </svg>
    </Box>
  );
};

IconError.propTypes = {
  fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default IconError;
